import contentControls from "./contentControlsService";
import { REPEATING_CONTENT_BLOCK } from "@/constants/contentControlTypes";
import { REPEATING_CONTENT_BLOCK as BLOCK_COLOR } from "@/constants/contentControlColors";
import { tryLoadProperties } from "@/util/wordUtil";

const add = (name, hideBoundingBox = false) => new Promise(resolve => {
    const title = `Sharedo ${REPEATING_CONTENT_BLOCK}: ${name}`;
    const options = {
        placeholderText: title,
        color: BLOCK_COLOR,
        tag: name,
        hideBoundingBox
    };

    contentControls.insert(title, options, async ({ contentControl, parentContentControl, context }) => {
        tryLoadProperties(context, contentControl, "id").then(() => {
            const retVal = { id: contentControl.id };

            if (parentContentControl) {
                retVal.parentId = parentContentControl.id;
            }

            resolve(retVal);
        });
    });
});

export default {
    add,
}